import {UserRepository} from '../repository/UserRepository';
import {UserRepositoryImpl} from '../repository/UserRepositoryImpl';
import {CreateUserUseCase} from '../useCases/CreateUserUseCase';
import {GetUsersUseCase} from '../useCases/GetUsersUseCase';
import {GetUserByIdUseCase} from '../useCases/GetUserByIdUseCase';
import {UpdateUserUseCase} from '../useCases/UpdateUserUseCase';
import {UpdateUserPasswordUseCase} from '../useCases/UpdateUserPasswordUseCase';
import {DeleteUserUseCase} from '../useCases/DeleteUserUseCase';
import {AssignRoleUseCase} from '../useCases/AssignRoleUseCase';
import {RemoveRoleUseCase} from '../useCases/RemoveRoleUseCase';
import {ActivateUserUseCase} from '../useCases/ActivateUserUseCase';
import {DeactivateUserUseCase} from '../useCases/DeactivateUserUseCase';
import {GetUserStatisticsUseCase} from '../useCases/GetUserStatisticsUseCase';

class UserFactory {
  private static instance: UserFactory;
  private userRepository: UserRepository;
  private createUserUseCase: CreateUserUseCase;
  private getUsersUseCase: GetUsersUseCase;
  private getUserByIdUseCase: GetUserByIdUseCase;
  private updateUserUseCase: UpdateUserUseCase;
  private updateUserPasswordUseCase: UpdateUserPasswordUseCase;
  private deleteUserUseCase: DeleteUserUseCase;
  private assignRoleUseCase: AssignRoleUseCase;
  private removeRoleUseCase: RemoveRoleUseCase;
  private activateUserUseCase: ActivateUserUseCase;
  private deactivateUserUseCase: DeactivateUserUseCase;
  private getUserStatisticsUseCase: GetUserStatisticsUseCase;

  private constructor () {
    // Initialize repository
    this.userRepository = new UserRepositoryImpl();

    // Initialize use cases
    this.createUserUseCase = new CreateUserUseCase(this.userRepository);
    this.getUsersUseCase = new GetUsersUseCase(this.userRepository);
    this.getUserByIdUseCase = new GetUserByIdUseCase(this.userRepository);
    this.updateUserUseCase = new UpdateUserUseCase(this.userRepository);
    this.updateUserPasswordUseCase = new UpdateUserPasswordUseCase(this.userRepository);
    this.deleteUserUseCase = new DeleteUserUseCase(this.userRepository);
    this.assignRoleUseCase = new AssignRoleUseCase(this.userRepository);
    this.removeRoleUseCase = new RemoveRoleUseCase(this.userRepository);
    this.activateUserUseCase = new ActivateUserUseCase(this.userRepository);
    this.deactivateUserUseCase = new DeactivateUserUseCase(this.userRepository);
    this.getUserStatisticsUseCase = new GetUserStatisticsUseCase(this.userRepository);
  }

  static getInstance (): UserFactory {
    if (!UserFactory.instance) {
      UserFactory.instance = new UserFactory();
    }
    return UserFactory.instance;
  }

  getRepository (): { userRepository: UserRepository } {
    return {
      userRepository: this.userRepository
    };
  }

  getUseCases (): {
    createUserUseCase: CreateUserUseCase;
    getUsersUseCase: GetUsersUseCase;
    getUserByIdUseCase: GetUserByIdUseCase;
    updateUserUseCase: UpdateUserUseCase;
    updateUserPasswordUseCase: UpdateUserPasswordUseCase;
    deleteUserUseCase: DeleteUserUseCase;
    assignRoleUseCase: AssignRoleUseCase;
    removeRoleUseCase: RemoveRoleUseCase;
    activateUserUseCase: ActivateUserUseCase;
    deactivateUserUseCase: DeactivateUserUseCase;
    getUserStatisticsUseCase: GetUserStatisticsUseCase;
  } {
    return {
      createUserUseCase: this.createUserUseCase,
      getUsersUseCase: this.getUsersUseCase,
      getUserByIdUseCase: this.getUserByIdUseCase,
      updateUserUseCase: this.updateUserUseCase,
      updateUserPasswordUseCase: this.updateUserPasswordUseCase,
      deleteUserUseCase: this.deleteUserUseCase,
      assignRoleUseCase: this.assignRoleUseCase,
      removeRoleUseCase: this.removeRoleUseCase,
      activateUserUseCase: this.activateUserUseCase,
      deactivateUserUseCase: this.deactivateUserUseCase,
      getUserStatisticsUseCase: this.getUserStatisticsUseCase
    };
  }
}

export const userFactory = UserFactory.getInstance();
